"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleTransport = void 0;
var ConsoleTransport = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    function ConsoleTransport(formatter) {
        this.formatter = formatter;
    }
    ConsoleTransport.prototype.write = function (appLog) {
        var log = this.formatter.format(appLog);
        switch (appLog.level) {
            case 'fatal':
            case 'error':
                console.error(log);
                return;
            case 'warning':
                console.warn(log);
                return;
            case 'info':
                console.info(log);
                return;
            case 'debug':
                console.debug(log);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(log);
        }
    };
    return ConsoleTransport;
}());
exports.ConsoleTransport = ConsoleTransport;
//# sourceMappingURL=ConsoleTransport.js.map